export default __webpack_public_path__ + "static/media/bg-world.79240cd2.png";